import application from 'application/application';

application

	.filter('highlight', function($sce) {

		return function(text, phrase) {

			if (phrase)

				text = text.replace(new RegExp('(' + phrase + ')', 'gi'), '<b>$1</b>');

			return $sce.trustAsHtml(text);

		};

	});
